/* Progressive enhancement only: the existing select/change handler owns the cart selection. */
(function () {
  'use strict';
  if (window.__sentyrScentPickerReady) return;
  window.__sentyrScentPickerReady = true;
  var states = new Map();
  var opened = null;
  var recentChoice = null;
  var recentPointer = null;

  function pointerClick(event) {
    return event.detail > 0 || !!event.pointerType || !!(event.sourceCapabilities && event.sourceCapabilities.firesTouchEvents) ||
      !!(recentPointer && recentPointer.target === event.target && Date.now() - recentPointer.time < 1000);
  }
  function sameChoicePoint(event) {
    return Math.abs(event.clientX - recentChoice.x) <= 16 && Math.abs(event.clientY - recentChoice.y) <= 16;
  }
  function rememberChoice(event) {
    if (event && pointerClick(event) && Number.isFinite(event.clientX) && Number.isFinite(event.clientY)) {
      recentChoice = { x: event.clientX, y: event.clientY, time: Date.now() };
    }
  }
  /* Window capture runs before the existing PDP document/capture ATC handler.
     Closing the popup must not retarget the second click/tap onto the button underneath. */
  window.addEventListener('click', function (event) {
    if (!recentChoice) return;
    if (Date.now() - recentChoice.time > 500 || !pointerClick(event) || !sameChoicePoint(event)) {
      recentChoice = null;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  window.addEventListener('pointerdown', function (event) {
    recentPointer = { target: event.target, time: Date.now() };
    if (recentChoice && !sameChoicePoint(event)) recentChoice = null;
  }, true);
  window.addEventListener('pointermove', function (event) {
    if (recentChoice && !sameChoicePoint(event)) recentChoice = null;
  }, true);
  window.addEventListener('keydown', function () { recentChoice = null; recentPointer = null; }, true);

  function isAvailable(state, index) {
    var option = state.select.options[index];
    return !!option && !option.disabled && option.dataset.available !== 'false';
  }
  function canOpen(state) {
    var product = state.root.closest('[data-el-pdp]');
    var offer = state.root.closest('.sentyr-offer');
    return state.root.isConnected && !state.select.disabled && !(product && product.__elAdding) && (!offer || offer.classList.contains('active'));
  }
  function imageFor(state, value) {
    var source = state.images.find(function (img) { return img.getAttribute('data-picker-variant') === value; });
    if (!source) return null;
    var img = source.cloneNode(true);
    img.removeAttribute('data-picker-variant');
    return img;
  }
  function fillMedia(node, img) {
    node.replaceChildren();
    if (img) node.appendChild(img);
  }
  function close(state, restoreFocus) {
    if (!state) return;
    var hadFocus = state.popup.contains(document.activeElement);
    state.popup.hidden = true;
    state.button.setAttribute('aria-expanded', 'false');
    state.root.classList.remove('is-open', 'is-above');
    state.list.removeAttribute('aria-activedescendant');
    if (opened === state) opened = null;
    if (restoreFocus && hadFocus && !state.button.disabled && state.root.isConnected) state.button.focus({ preventScroll: true });
  }
  function highlight(state, index, scroll) {
    state.highlight = index;
    state.rows.forEach(function (row, i) { row.classList.toggle('is-highlighted', i === index); });
    var row = state.rows[index];
    if (!row) { state.list.removeAttribute('aria-activedescendant'); return; }
    state.list.setAttribute('aria-activedescendant', row.id);
    if (scroll) {
      if (row.offsetTop < state.list.scrollTop) state.list.scrollTop = row.offsetTop;
      else if (row.offsetTop + row.offsetHeight > state.list.scrollTop + state.list.clientHeight) state.list.scrollTop = row.offsetTop + row.offsetHeight - state.list.clientHeight;
    }
  }
  function paint(state) {
    var option = state.select.options[state.select.selectedIndex];
    state.name.textContent = option ? option.dataset.title || option.textContent : 'Choisir une senteur';
    state.inspiration.textContent = option && option.dataset.inspired ? 'Inspiré de ' + option.dataset.inspired : '';
    state.inspiration.hidden = !state.inspiration.textContent;
    fillMedia(state.media, option ? imageFor(state, option.value) : null);
    state.button.disabled = state.select.disabled;
    state.button.setAttribute('aria-label', state.label + ' : ' + state.name.textContent + (option && !isAvailable(state, state.select.selectedIndex) ? ', épuisé' : ''));
    state.rows.forEach(function (row, i) {
      row.setAttribute('aria-selected', i === state.select.selectedIndex ? 'true' : 'false');
      row.setAttribute('aria-disabled', isAvailable(state, i) ? 'false' : 'true');
      row.querySelector('[data-picker-unavailable]').hidden = isAvailable(state, i);
    });
    if (!canOpen(state)) close(state, false);
  }
  function buildRows(state) {
    state.list.replaceChildren();
    state.rows = Array.from(state.select.options).map(function (option, index) {
      var row = document.createElement('li');
      row.className = 'sentyr-scent-picker__option';
      row.id = state.select.id + '-option-' + index;
      row.setAttribute('role', 'option');
      row.setAttribute('data-picker-index', String(index));
      var media = document.createElement('span');
      media.className = 'sentyr-scent-picker__media';
      media.setAttribute('aria-hidden', 'true');
      fillMedia(media, imageFor(state, option.value));
      var copy = document.createElement('span');
      copy.className = 'sentyr-scent-picker__copy';
      var name = document.createElement('span');
      name.className = 'sentyr-scent-picker__name';
      name.textContent = option.dataset.title || option.textContent;
      copy.appendChild(name);
      if (option.dataset.inspired) {
        var inspiration = document.createElement('small');
        inspiration.textContent = 'Inspiré de ' + option.dataset.inspired;
        copy.appendChild(inspiration);
      }
      var unavailable = document.createElement('span');
      unavailable.className = 'sentyr-scent-picker__availability';
      unavailable.setAttribute('data-picker-unavailable', '');
      unavailable.textContent = 'Épuisé';
      copy.appendChild(unavailable);
      row.appendChild(media);
      row.appendChild(copy);
      state.list.appendChild(row);
      return row;
    });
    paint(state);
  }
  function boundary(state, last) {
    var indices = state.rows.map(function (_, i) { return i; }).filter(function (i) { return isAvailable(state, i); });
    return indices.length ? indices[last ? indices.length - 1 : 0] : -1;
  }
  function place(state) {
    var rect = state.button.getBoundingClientRect();
    var below = window.innerHeight - rect.bottom;
    var above = rect.top;
    var useAbove = below < 240 && above > below;
    state.root.classList.toggle('is-above', useAbove);
    state.list.style.setProperty('--sentyr-picker-list-height', Math.max(80, Math.min(360, (useAbove ? above : below) - 24)) + 'px');
  }
  function open(state, edge) {
    paint(state);
    if (!canOpen(state) || boundary(state, false) < 0) return;
    if (opened && opened !== state) close(opened, false);
    opened = state;
    state.popup.hidden = false;
    state.root.classList.add('is-open');
    state.button.setAttribute('aria-expanded', 'true');
    state.search = '';
    place(state);
    var index = edge === 'first' ? boundary(state, false) : edge === 'last' ? boundary(state, true) : state.select.selectedIndex;
    if (!isAvailable(state, index)) index = boundary(state, false);
    highlight(state, index, true);
    state.list.focus({ preventScroll: true });
  }
  function move(state, direction) {
    for (var step = 1; step <= state.rows.length; step++) {
      var next = (state.highlight + direction * step + state.rows.length) % state.rows.length;
      if (isAvailable(state, next)) { highlight(state, next, true); return; }
    }
  }
  function choose(state, index, event) {
    if (!canOpen(state) || !isAvailable(state, index)) return;
    rememberChoice(event);
    state.select.selectedIndex = index;
    state.select.dispatchEvent(new Event('change', { bubbles: true }));
    paint(state);
    close(state, true);
  }
  function getState(target) {
    return target instanceof Element ? states.get(target.closest('[data-sentyr-scent-picker]')) : null;
  }
  function destroy(state) {
    close(state, false);
    if (state.observer) state.observer.disconnect();
    state.button.hidden = true;
    state.select.hidden = state.nativeHidden;
    state.root.removeAttribute('data-picker-ready');
    states.delete(state.root);
  }
  function init(scope) {
    var nodes = [];
    if (scope instanceof Element && scope.matches('[data-sentyr-scent-picker]')) nodes.push(scope);
    scope.querySelectorAll('[data-sentyr-scent-picker]').forEach(function (root) { nodes.push(root); });
    nodes.forEach(function (root) {
      if (states.has(root) || window.getComputedStyle(root).getPropertyValue('--sentyr-picker-css-ready').trim() !== '1') return;
      var select = root.querySelector('.sentyr-scent-select');
      var button = root.querySelector('[data-picker-trigger]');
      var popup = root.querySelector('[data-picker-popup]');
      var list = root.querySelector('[data-picker-list]');
      var template = root.querySelector('[data-picker-images]');
      if (!select || !button || !popup || !list || !template || !select.options.length) return;
      var state = { root: root, select: select, button: button, popup: popup, list: list, nativeHidden: select.hidden,
        name: button.querySelector('[data-picker-name]'), inspiration: button.querySelector('[data-picker-inspiration]'), media: button.querySelector('[data-picker-media]'),
        label: select.getAttribute('aria-label') || 'Choisir une senteur', images: Array.from(template.content.querySelectorAll('img[data-picker-variant]')), rows: [], highlight: -1 };
      try {
        if (!state.name || !state.inspiration || !state.media) return;
        buildRows(state);
        state.observer = new MutationObserver(function (records) {
          if (!root.isConnected) { destroy(state); return; }
          if (records.some(function (record) { return record.type === 'childList' || record.target !== select && select.contains(record.target); })) buildRows(state);
          else paint(state);
          if (opened === state && !isAvailable(state, state.highlight)) highlight(state, boundary(state, false), true);
        });
        state.observer.observe(select, { attributes: true, attributeFilter: ['disabled', 'selected', 'data-available'], childList: true, subtree: true });
        var offer = root.closest('.sentyr-offer');
        if (offer) state.observer.observe(offer, { attributes: true, attributeFilter: ['class'] });
        states.set(root, state);
        root.setAttribute('data-picker-ready', '');
        select.hidden = true;
        button.hidden = false;
      } catch (_) { destroy(state); }
    });
  }

  /* Keep these on document/capture: the existing PDP stops offer clicks there. */
  document.addEventListener('click', function (event) {
    var state = getState(event.target);
    if (state) {
      if (event.target.closest('[data-picker-trigger]')) {
        event.preventDefault(); event.stopPropagation();
        if (opened === state) close(state, false); else open(state);
        return;
      }
      var row = event.target.closest('[data-picker-index]');
      if (row && state.list.contains(row)) {
        event.preventDefault(); event.stopPropagation();
        choose(state, Number(row.getAttribute('data-picker-index')), event);
        return;
      }
    }
    var label = event.target instanceof Element && event.target.closest('label[for]');
    if (label) states.forEach(function (candidate) {
      if (label.htmlFor === candidate.select.id && !candidate.button.disabled) { event.preventDefault(); candidate.button.focus(); }
    });
    if (opened && !opened.root.contains(event.target)) close(opened, false);
  }, true);
  document.addEventListener('pointerdown', function (event) {
    if (opened && !opened.root.contains(event.target)) close(opened, false);
  }, true);
  document.addEventListener('focusin', function (event) {
    if (opened && !opened.root.contains(event.target)) close(opened, false);
  }, true);
  document.addEventListener('keydown', function (event) {
    var state = getState(event.target);
    if (!state || event.altKey || event.ctrlKey || event.metaKey) return;
    var key = event.key;
    if (key === 'Tab') {
      if (opened === state) close(state, true);
      return;
    }
    if (key === 'Escape') {
      if (opened === state) { event.preventDefault(); event.stopPropagation(); close(state, true); }
      return;
    }
    if (['ArrowDown', 'ArrowUp', 'Home', 'End', 'Enter', ' '].indexOf(key) !== -1) {
      event.preventDefault(); event.stopPropagation();
      if (opened !== state) open(state, key === 'Home' ? 'first' : key === 'End' ? 'last' : undefined);
      else if (key === 'Enter' || key === ' ') choose(state, state.highlight);
      else if (key === 'Home' || key === 'End') highlight(state, boundary(state, key === 'End'), true);
      else move(state, key === 'ArrowDown' ? 1 : -1);
      return;
    }
    if (key.length === 1 && !event.isComposing) {
      if (opened !== state) open(state);
      if (opened !== state) return;
      var now = Date.now();
      state.search = now - (state.searchTime || 0) < 600 ? state.search + key : key;
      state.searchTime = now;
      var query = state.search.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      for (var n = 1; n <= state.rows.length; n++) {
        var index = (state.highlight + n) % state.rows.length;
        var option = state.select.options[index];
        var name = (option.dataset.title || option.textContent).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        if (isAvailable(state, index) && name.indexOf(query) === 0) { highlight(state, index, true); break; }
      }
      event.preventDefault(); event.stopPropagation();
    }
  }, true);
  document.addEventListener('change', function (event) {
    var state = getState(event.target);
    if (state && event.target === state.select) { paint(state); if (opened === state) close(state, true); }
  }, true);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    states.forEach(function (state) { if (event.target.contains(state.root)) destroy(state); });
  });
  document.addEventListener('load', function (event) {
    if (event.target instanceof HTMLLinkElement && event.target.href.indexOf('sentyr-scent-picker.css') !== -1) init(document);
  }, true);
  window.addEventListener('resize', function () {
    if (!opened) return;
    var rect = opened.button.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) close(opened, true);
    else place(opened);
  });
  window.addEventListener('pagehide', function () { recentChoice = null; recentPointer = null; if (opened) close(opened, false); });
  window.addEventListener('pageshow', function () { states.forEach(paint); init(document); });
  function start() {
    init(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) { record.removedNodes.forEach(function (node) {
        states.forEach(function (state) { if (node.contains && node.contains(state.root) && !state.root.isConnected) destroy(state); });
      }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
